import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import { getPersonalitySaboteurAPIHelper, getPersonalityTestResultAPIHelper } from '../helpers/numerologyAPI';
// import {getPersonalityTestResultAPIHelper} from '../../helpers/numerologyAPI';

// interface InitialStateProps {
//   personalityTestResult: object | null;
// }

const initialState= {
  personalityTestResult: null,
  saboteurresult:null,
};

export const getPersonalityTestResult = createAsyncThunk(
  '/numerology/get-personality-result',
  async (_, thunkAPI) => {
    try {
      const response = await getPersonalityTestResultAPIHelper();
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  },
);

export const getPersonalitySaboteur = createAsyncThunk(
  '/numerology/get-personality-saboteur',
  async (_, thunkAPI) => {
    try {
      const response = await getPersonalitySaboteurAPIHelper();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

const numerologySlice = createSlice({
  name: 'numerology',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPersonalityTestResult.pending, (state, action) => {
        console.log('action getPersonalityTestResult pending');
      })
      .addCase(getPersonalityTestResult.fulfilled, (state, action) => {
        state.personalityTestResult = action?.payload?.data || null;
        console.log('action getPersonalityTestResult fulfilled', action);
      })
      .addCase(getPersonalityTestResult.rejected, (state, action) => {
        console.log(
          'action getPersonalityTestResult rejected',
          action?.payload,
        );
      })
       .addCase(getPersonalitySaboteur.pending, (state, action) => {
        console.log('action getSaboteur pending');
      })
      .addCase(getPersonalitySaboteur.fulfilled, (state, action) => {
        state.saboteurresult = action?.payload?.data || null;
        console.log('action getSaboteur fulfilled', action);
      })
      .addCase(getPersonalitySaboteur.rejected, (state, action) => {
        console.log(
          'action getPersonalitySaboteur rejected',
          action?.payload,
        );
      });
  },
});

export const {} = numerologySlice.actions;
export default numerologySlice.reducer;
